import logo from './logo.svg';
import './App.css';
import CarGallery from "./components/CarGallery";


function App() {
  return (
    <div>
       <CarGallery />
    </div>
  );
}

export default App;
